import { detectIncognito } from 'detectincognitojs';

/**
 * Checks whether the browser is in incognito / private mode
 * @returns {Promise<boolean>} true if in incognito mode, otherwise false
 */
export async function checkIncognitoMode() {
  try {
    const { isPrivate } = await detectIncognito();
    return isPrivate;
  } catch (error) {
    console.error('Error detecting incognito mode:', error);
    return false; // On error, assume not in incognito
  }
}
